<template>
	<div
		ref="wrapper"
		class="all-reviews-wrapper container bg-primary-white py-2 py-lg-3 px-lg-5 mb-5 mb-md-0"
	>
		<Overlay
			:position="'fixed'"
			:open="state.loading"
			:color="'rgba(13, 20, 27, 0.65)'"
			:classes="''"
			:maxOpacity="1"
			:contentTimeout="110"
			:zIndex="2002"
		>
			<div v-if="state.loading">
				<div class="loader position-fixed"></div>
			</div>
		</Overlay>
		<div
			class="all-reviews-content-wrapper"
			style="height: 100%; grid-template-rows: 1fr 1000fr 1fr"
			:style="{
				visibility: data.reviewsToShow.length === 0 ? 'hidden' : 'visible',
			}"
		>
			<div class="popup-header-wrapper">
				<!-- back button -->
				<button
					@click.stop="handleClose"
					class="ts-x-black ts-x-md cursor-pointer position-absolute close"
				></button>

				<!-- total reviews -->
				<div class="row my-2">
					<div class="col-12">
						<span class="title-2 text-grey-900"
							>{{ content["all_reviews_title"] }}
							{{  " " }}
						</span>
						<span class="body-strong text-grey-700">
							{{ data.totalReviews }}
							{{ content["topPage_review"] }}
						</span>
					</div>
				</div>

				<!-- lihe name -->
				<div class="row my-2">
					<div class="col-12">
						<span class="heading text-grey-900">{{ lihe.name }}</span>
					</div>
				</div>

				<BorderHorizontal />

				<!-- filter -->
				<div class="row my-2">
					<div class="col-12">
						<div
							class="d-flex flex-column flex-lg-row nowrap justify-content-center justify-content-lg-start"
							style="gap: 15px"
						>
							<span class="body text-grey-900"
								>{{ content["all_reviews_filter"] }}:
							</span>
							<ReviewFilter
								:filterItems="filterItems"
								:currentFilterItemIndex="state.currentFilterItemIndex"
								@filter="(item_i) => handleFilter(item_i)"
							/>
						</div>
					</div>
				</div>
			</div>

			<!-- reviews -->
			<div
				ref="reviews-wrapper"
				class="reviews-wrapper py-2"
				style="overflow-y: auto; max-height: 100%"
			>
				<div class="d-flex flex-column nowrap" style="gap: 20px">
					<Review
						v-for="(review, review_i) in data.reviewsToShow"
						:key="review_i"
						:review="review"
					/>
				</div>
			</div>

			<!-- pagination -->
			<div>
				<div class="d-flex justify-content-center py-4">
					<Pagination
						:page="state.pageNo"
						:total="state.total"
						@set-page="(pageNo) => handlePageClick(pageNo)"
					/>
				</div>
			</div>

			<!-- mobile back btn -->
			<div class="pb-3">
				<div
					@click.stop="handleClose"
					class="button-primary primary-normal cursor-pointer d-flex align-items-center justify-content-center d-lg-none"
				>
					<span>{{ content["all_reviews_back"] }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ReviewFilter from "./filter.vue";
import Pagination from "./pagination.vue";
import Review from "./review.vue";
import { mapState, mapGetters } from "vuex";
import allReviewsFilterConfig from "@/config/allReviewsFilterConfig";
import Overlay from "@/vue/common/overlay.vue";
import BorderHorizontal from "@/vue/common/borderHorizontal.vue";

export default {
	name: "AllReviews",
	components: {
		ReviewFilter,
		Pagination,
		Review,
		Overlay,
		BorderHorizontal,
	},
	data() {
		return {
			lihe: window.lihe,
			allReviewsFilterConfig,
			data: {
				responses: {},
				reviewsToShow: [],
				totalReviews: null,
			},
			state: {
				currentFilterItemIndex: 0,
				pageNo: 0,
				total: null,
				loading: false,
			},
		};
	},
	computed: {
		...mapState([
			"content",
			"ssrReviewData",
			"reviewsArray",
			"ratingsToShow",
			"viewDetailClicked",
			"screenType",
			"language",
			"feature"
		]),
		...mapGetters(["locale"]),
		filterItems() {
			const arr = [];
			allReviewsFilterConfig.forEach((value) => {
				const obj = {};
				obj["value"] = value;
				obj["label"] = this.content[`all_reviews_${value}`];
				arr.push(obj);
			});
			return arr;
		},
		filterParams() {
			const currentFilter = this.filterItems[this.state.currentFilterItemIndex];
			switch (currentFilter.value) {
				case "top_marks":
					return { sortFields: "rate", sortDirs: "DESC" };
				case "lowest_marks":
					return { sortFields: "rate", sortDirs: "ASC" };
				case "most_recent":
					return { sortFields: "date", sortDirs: "DESC" };
				default:
					return {};
			}
		},
	},

	

	methods: {
		handleClose() {
			this.$emit("closePopup");
		},

		async handlePageClick(pageNo) {
			this.state.pageNo=pageNo;
			this.$refs["reviews-wrapper"].scrollTop = 0;
			this.$refs["wrapper"].closest(".popup.container").scrollTop = 0;
			await this.getReviews(this.state.pageNo);
		},

		handleFilter(item_i) {
			this.state.currentFilterItemIndex=item_i;
		},

		getResponseKey(pageNo, sortFields, sortDirs) {
			return `${pageNo}-${JSON.stringify(sortFields)}-${JSON.stringify(
				sortDirs
			)}`;
		},

		async getReviews(pageNo) {
			const { sortFields, sortDirs } = this.filterParams;

			const key = this.getResponseKey(pageNo, sortFields, sortDirs);
			if (this.data.responses[key]) {
				this.data.reviewsToShow = this.data.responses[key];
				return;
			}

			console.log(
				`[AllReviews] getReviews → page: ${pageNo}`,
				{ sortFields, sortDirs, key }
			);


			const locale = this.locale;
			const pageSize = 5;
			const start = pageNo * pageSize;
			const liheId = window.lihe.id;

			this.state.loading=true;
			console.log("[AllReviews] Loading reviews from service…");

			const requestData = {
				locale,
				size: pageSize,
				start,
				liheId,
				sortFields,
				sortDirs,
			};

			const raw = await window.reviewService.getRateByLihe(requestData);
			console.log("raw in all reviews", raw)
			const res = raw.message.rate;
			console.log("res in all reviews", res);
			const newRespObj = {};
			newRespObj[key] = res.reviews;
			this.data.responses={
				...this.data.responses,
				...newRespObj,
			};
			this.state.total=res.pageCount;
			this.data.totalReviews=res.reviewsSize;
			this.data.reviewsToShow=this.data.responses[key];
			this.state.loading=false;
		},
	},

	watch: {
		screenType(newType) {
		console.log("[AllReviews] screenType →", newType);
		},
		"data.reviewsToShow"(newList) {
		console.log("[AllReviews] reviewsToShow →", newList.length, newList);
		},
		filterParams: async function () {
			this.state.pageNo = 0;
			const reviewsWrapper = this.$refs["reviews-wrapper"];
			const outer = this.$refs["wrapper"];
			if (reviewsWrapper) reviewsWrapper.scrollTop = 0;
			if (outer) {
				const popup = outer.closest(".popup.container");
				if (popup) popup.scrollTop = 0;
			}
			await this.getReviews(0);
		},
	},

	async mounted() {
		await this.getReviews(this.state.pageNo);
	},
};
</script>

<style>
.mobile-back-btn {
	background: var(--primary-blue); /* Using primary-blue instead of custom rgb(82, 179, 216) */
	padding: 15px;
	border-radius: var(--border-radius-card);
	color: var(--primary-white);
}

.popup-header-wrapper {
  position: sticky;
  top: 0;
  background: var(--primary-white);
  z-index: 20;
  padding-top: 1rem;
}

.all-reviews-wrapper {
	min-height: 80vh;
	border-radius: var(--border-radius-card-secondary);
}
@media (min-width: 992px) {
	.all-reviews-wrapper {
		height: 80vh;
	}
	.all-reviews-content-wrapper {
		display: grid;
	}
}

.close {
	right: 2.9em;
	top: 2em;
}

@media (max-width: 768px) {
	.close {
		right: 10px;
		top: 10px;
	}
	.all-reviews-wrapper {
		margin-bottom: 100px;
	}
}
</style>
